import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { InspecaoPallet } from '../../types/qualidade';
import { inspecoesService } from '../../services';

const columns: ResourceColumn<InspecaoPallet>[] = [
  { header: 'Lote', accessor: 'lote' },
  { header: 'Resultado', accessor: 'resultado' },
  { header: 'Responsável', accessor: 'responsavel' },
  { header: 'Observações', accessor: 'observacoes' },
];

export const InspecoesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Inspeções"
    description="Inspeções de qualidade executadas."
    columns={columns}
    service={inspecoesService}
    createPath="/admin/qualidade/inspecoes/novo"
      onEdit={(item) => item.id && navigate("/admin/qualidade/inspecoes/editar", { state: { record: item } })}
  />
  );
};